import { Box, styled } from '@mui/system';
import { Typography } from '@mui/material';

export const TooltipContent = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1)
}));

export const CodeExampleBox = styled(Box)(() => ({
  fontFamily: 'monospace',
  fontSize: '0.75rem'
}));
